module.exports = __webpack_public_path__ + "static/media/debt-credit-v4.8c4ed15b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/debt-credit-v4.svg
// module id = 82
// module chunks = 0